import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage, userByEmail } from '../../../services';

import Loading from '../../../components/Loading/LoadingModule';

import '../../../libs/bulma.min.css';
import './UsersView.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPen, faArrowLeft, faUser, faEnvelope, faPhone, faShieldAlt, faCheckCircle, faTimesCircle, faBuilding, faList } from '@fortawesome/free-solid-svg-icons';

function UsersView() {
  const getItensStateGlobal = useContext(PbxContext);
  const { itemsSelectedToEdit, toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  const validateUserLogged = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    if (!dataUser) return history.push('/');
    if (dataUser && dataUser.user?.role !== 'root') return history.push('/home');
    
    if (!itemsSelectedToEdit) {
      return history.push('/config/usuarios/lista');
    }

    let userData = itemsSelectedToEdit;
    
    if (typeof itemsSelectedToEdit === 'string') {
      const fetchedUser = await userByEmail({ email: itemsSelectedToEdit });
      if (!fetchedUser || fetchedUser === 400) {
        return history.push('/config/usuarios/lista');
      }
      userData = fetchedUser;
    }

    const { role, idtenant } = dataUser.user;
    const isRootVgs = role === 'root' && idtenant === 'vgs';

    if (!isRootVgs && userData.idtenant !== idtenant) {
      return history.push('/config/usuarios/lista');
    }

    setUser(userData);
    setLoading(false);
  }, [history, itemsSelectedToEdit]);

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  const handleEdit = () => {
    if (user && user.email) {
      setItemsSelectedToEdit(user.email);
      toggleIsChangeFormElements();
      toggleIsHidden();
      history.push('/config/usuarios/editar');
    }
  };

  const getRoleDisplay = (role) => {
    if (role === 'root') return 'Técnico';
    if (role === 'admin') return 'Administrativo';
    return 'Usuário';
  };

  const getRoleBadgeClass = (role) => {
    if (role === 'root') return 'badge-role-root';
    if (role === 'admin') return 'badge-role-admin';
    return 'badge-role-user';
  };

  const getEndpointsviewerDisplay = (listEndpoint) => {
    if (!listEndpoint) return 'Nenhum';
    if (listEndpoint === 'all') return 'Todos';
    if (listEndpoint === 'none') return 'Nenhum';
    if (Array.isArray(listEndpoint)) return listEndpoint.join(', ');
    if (typeof listEndpoint === 'string' && listEndpoint.includes(',')) {
      return listEndpoint.split(',').map(e => e.trim()).join(', ');
    }
    return listEndpoint;
  };

  const getQueuesviewerDisplay = (listQueues) => {
    if (!listQueues) return 'Nenhuma';
    if (listQueues === 'all') return 'Todas';
    if (listQueues === 'none') return 'Nenhuma';
    if (Array.isArray(listQueues)) return listQueues.join(', ');
    if (typeof listQueues === 'string' && listQueues.includes(',')) {
      return listQueues.split(',').map(e => e.trim()).join(', ');
    }
    return listQueues;
  };

  const formatEndpointsList = (endpointsviewer) => {
    if (!endpointsviewer || endpointsviewer === 'none') return [];
    if (endpointsviewer === 'all') return ['Todos os ramais'];
    if (Array.isArray(endpointsviewer)) return endpointsviewer;
    if (typeof endpointsviewer === 'string' && endpointsviewer.includes(',')) {
      return endpointsviewer.split(',').map(e => e.trim());
    }
    return [endpointsviewer];
  };

  const formatQueuesList = (queuesviewer) => {
    if (!queuesviewer || queuesviewer === 'none') return [];
    if (queuesviewer === 'all') return ['Todas as filas'];
    if (Array.isArray(queuesviewer)) return queuesviewer;
    if (typeof queuesviewer === 'string' && queuesviewer.includes(',')) {
      return queuesviewer.split(',').map(e => e.trim());
    }
    return [queuesviewer];
  };

  if (loading || !user) return <Loading />;

  return (
    <div className="users-view-container">
      <div className="users-view-header">
        <div className="users-view-title-wrapper">
          <svg className="users-view-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <div>
            <h1 className="users-view-title">Visualizar Usuário</h1>
            <p className="users-view-subtitle">{user.name || user.email}</p>
          </div>
        </div>
        <div className="users-view-actions">
          <button 
            className="btn-action-view btn-edit-view"
            onClick={handleEdit}
          >
            <FontAwesomeIcon icon={faPen} />
            Editar
          </button>
          <Link to="/config/usuarios/lista" className="btn-action-view btn-back-view">
            <FontAwesomeIcon icon={faArrowLeft} />
            Voltar
          </Link>
        </div>
      </div>

      <div className="details-grid">
        <div className="details-card">
          <h2 className="details-section-title">
            <FontAwesomeIcon icon={faUser} className="details-section-icon" />
            Informações Pessoais
          </h2>
                  
          <div className="detail-field">
            <label className="detail-label">Nome</label>
            <div className="detail-value">
              {user.name || <span className="detail-value-empty">Não informado</span>}
            </div>
          </div>

          <div className="detail-field">
            <label className="detail-label">E-mail</label>
            <div className="detail-value">
              {user.email || <span className="detail-value-empty">Não informado</span>}
            </div>
            <p className="detail-value-help">E-mail usado para login no sistema</p>
          </div>

          <div className="detail-field">
            <label className="detail-label">Ramal</label>
            <div className="detail-value">
              {user.endpoint ? (
                <span className="detail-value-badge badge-endpoint">
                  {user.endpoint}
                </span>
              ) : (
                <span className="detail-value-empty">Não atribuído</span>
              )}
            </div>
            <p className="detail-value-help">Ramal associado ao usuário</p>
          </div>
        </div>

        <div className="details-card">
          <h2 className="details-section-title">
            <FontAwesomeIcon icon={faShieldAlt} className="details-section-icon" />
            Permissões e Acesso
          </h2>
                  
          <div className="detail-field">
            <label className="detail-label">Tipo de Usuário</label>
            <div className="detail-value">
              <span className={`detail-value-badge ${getRoleBadgeClass(user.role)}`}>
                {getRoleDisplay(user.role)}
              </span>
            </div>
            <p className="detail-value-help">Nível de acesso no sistema</p>
          </div>

          <div className="detail-field">
            <label className="detail-label">Status</label>
            <div className="detail-value">
              <span className={`detail-value-badge ${user.active ? 'badge-active' : 'badge-inactive'}`}>
                {user.active ? (
                  <>
                    <FontAwesomeIcon icon={faCheckCircle} style={{ marginRight: '0.5rem' }} />
                    Ativo
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faTimesCircle} style={{ marginRight: '0.5rem' }} />
                    Inativo
                  </>
                )}
              </span>
            </div>
            <p className="detail-value-help">Estado atual da conta</p>
          </div>

          <div className="detail-field">
            <label className="detail-label">Tenant</label>
            <div className="detail-value">
              {user.idtenant ? (
                <span className="detail-value-badge badge-tenant">
                  {user.idtenant}
                </span>
              ) : (
                <span className="detail-value-empty">Não atribuído</span>
              )}
            </div>
            <p className="detail-value-help">Cliente/Organização associada</p>
          </div>
        </div>

        <div className="details-card details-card-full">
          <h2 className="details-section-title">
            <FontAwesomeIcon icon={faList} className="details-section-icon" />
            Visibilidade de Recursos
          </h2>
                  
          <div className="detail-field">
            <label className="detail-label">Ramais Visíveis</label>
            <div className="detail-value">
              {formatEndpointsList(user.endpointsviewer).length > 0 ? (
                <ul className="list-items">
                  {formatEndpointsList(user.endpointsviewer).map((endpoint, index) => (
                    <li key={index} className="list-item">
                      {endpoint}
                    </li>
                  ))}
                </ul>
              ) : (
                <span className="detail-value-empty">Nenhum ramal visível</span>
              )}
            </div>
            <p className="detail-value-help">Ramais que o usuário pode visualizar e gerenciar</p>
          </div>

          <div className="detail-field">
            <label className="detail-label">Filas Visíveis</label>
            <div className="detail-value">
              {formatQueuesList(user.queuesviewer).length > 0 ? (
                <ul className="list-items">
                  {formatQueuesList(user.queuesviewer).map((queue, index) => (
                    <li key={index} className="list-item">
                      {queue}
                    </li>
                  ))}
                </ul>
              ) : (
                <span className="detail-value-empty">Nenhuma fila visível</span>
              )}
            </div>
            <p className="detail-value-help">Filas que o usuário pode visualizar e gerenciar</p>
          </div>
        </div>
      </div>

      <div className="view-actions-footer">
        <button 
          className="btn-action-view btn-edit-view"
          onClick={handleEdit}
        >
          <FontAwesomeIcon icon={faPen} />
          Editar Usuário
        </button>
        <Link to="/config/usuarios/lista" className="btn-action-view btn-back-view">
          <FontAwesomeIcon icon={faArrowLeft} />
          Voltar para Lista
        </Link>
      </div>
    </div>
  );
}

export default UsersView;

